export enum DataGridActionType {
  Insert = 'insert',
  Update = 'update',
  Remove = 'remove',
}
